import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The one-sentence line under a main page's `<h1>`, telling the organiser what
 * the page is and what they can do on it.
 *
 * Every main page (My Events, Requests Manager, Quotes Manager, My Bookings)
 * uses this component so the styling cannot drift between them. Project the
 * sentence as content and place it inside the same container as the `<h1>`, so
 * the two share a left edge:
 *
 * ```html
 * <h1>My Events</h1>
 * <app-page-subtitle>See your events, or create a new event.</app-page-subtitle>
 * ```
 *
 * Copy follows `ate-shared/style-guides/ux.md`: one short sentence in the
 * second person. The text wraps rather than truncating, so it stays readable
 * on a narrow screen.
 */
@Component({
  selector: 'app-page-subtitle',
  templateUrl: './page-subtitle.component.html',
  standalone: true,
  styles: [
    `
      :host {
        display: block;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageSubtitleComponent {}
